import { Regions } from "@enonic/react-components";
import { PostenFooter } from "./footer";
import { PostenNavbar } from "./navbar";
import { ChatbotButton } from "./chatbot";

import "./hds-page.scss";

export const HdsPage = (props) => (
    <>
        <div className="kp-main-content">
            <PostenNavbar headerData={props.headerData} trackingUrl={props.trackingUrl} />
            {props.chatbot && <ChatbotButton chatbot={props.chatbot} />}
            <main id="main-content" className="kp-main-region" role="main" tabIndex={-1}>
                <Regions {...props} />
            </main>
            <PostenFooter footerData={props.footerData} />
            {props.chatbot && (
                <script
                    src={props.chatbot.scriptUrl}
                    id="init-kindly-chatbot"
                    data-language={props.language}
                    data-chatbot-name={props.chatbot.name}
                />
            )}
        </div>
    </>
);
